import React from "react";
import { IconSize, IconProps } from "../theme";

const Signout: React.FC<IconProps> = ({
  size = IconSize.M,
  color = "#071443",
}) => {
  return (
    <svg
      width={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 27C14 27.2652 13.8946 27.5196 13.7071 27.7071C13.5196 27.8946 13.2652 28 13 28H6C5.46957 28 4.96086 27.7893 4.58579 27.4142C4.21071 27.0391 4 26.5304 4 26V6C4 5.46957 4.21071 4.96086 4.58579 4.58579C4.96086 4.21071 5.46957 4 6 4H13C13.2652 4 13.5196 4.10536 13.7071 4.29289C13.8946 4.48043 14 4.73478 14 5C14 5.26522 13.8946 5.51957 13.7071 5.70711C13.5196 5.89464 13.2652 6 13 6H6V26H13C13.2652 26 13.5196 26.1054 13.7071 26.2929C13.8946 26.4804 14 26.7348 14 27ZM27.7075 15.2925L22.7075 10.2925C22.5676 10.1525 22.3894 10.0571 22.1953 10.0185C22.0012 9.97982 21.8 9.99963 21.6172 10.0754C21.4344 10.1511 21.2782 10.2794 21.1683 10.444C21.0584 10.6086 20.9998 10.8021 21 11V15H13C12.7348 15 12.4804 15.1054 12.2929 15.2929C12.1054 15.4804 12 15.7348 12 16C12 16.2652 12.1054 16.5196 12.2929 16.7071C12.4804 16.8946 12.7348 17 13 17H21V21C20.9998 21.1979 21.0584 21.3914 21.1683 21.556C21.2782 21.7206 21.4344 21.8489 21.6172 21.9246C21.8 22.0004 22.0012 22.0202 22.1953 21.9815C22.3894 21.9429 22.5676 21.8475 22.7075 21.7075L27.7075 16.7075C27.8005 16.6146 27.8742 16.5043 27.9246 16.3829C27.9749 16.2615 28.0008 16.1314 28.0008 16C28.0008 15.8686 27.9749 15.7385 27.9246 15.6171C27.8742 15.4957 27.8005 15.3854 27.7075 15.2925Z"
        fill={color}
      />
    </svg>
  );
};

export default Signout;
